import {Rectangle} from "pixi.js";
import {Anchor} from "../core/Anchor";
import {ContainerExtensions} from "../core/ContainerExtensions";
import {IRectangle} from "../core/Geom";
import {Sprite} from "../core/Sprite";
import {Button} from "./Button";
import {IFocusableRect} from "./Focusable";

export class ButtonPlay extends Button implements IFocusableRect {

    public onLayout() {
        this.addChildAt(new Sprite("button-play-glow", Anchor.middleCenter), 0);
        this.hitArea = new Rectangle(
            -this.visuals.width / 2,
            -this.visuals.height / 2,
            this.visuals.width,
            this.visuals.height,
        );
    }

    public getFocusRect(): IRectangle {
        return ContainerExtensions.getGlobalBounds.call(this.visuals);
    }
}
